// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsPayClaimsAbsencePropertyDto
 */
export interface IIsPayClaimsAbsencePropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsPayClaimsAbsencePropertyDto
     */
    is_pay_claims_absence?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsPayClaimsAbsencePropertyDto
     */
    is_pay_claims_absence_state?: IIsPayClaimsAbsencePropertyDtoIsPayClaimsAbsenceStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsPayClaimsAbsencePropertyDtoIsPayClaimsAbsenceStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsPayClaimsAbsencePropertyDto interface.
 */
export function instanceOfIIsPayClaimsAbsencePropertyDto(value: object): value is IIsPayClaimsAbsencePropertyDto {
    return true;
}

export function IIsPayClaimsAbsencePropertyDtoFromJSON(json: any): IIsPayClaimsAbsencePropertyDto {
    return IIsPayClaimsAbsencePropertyDtoFromJSONTyped(json, false);
}

export function IIsPayClaimsAbsencePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsPayClaimsAbsencePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_pay_claims_absence': json['is_pay_claims_absence'] == null ? undefined : json['is_pay_claims_absence'],
        'is_pay_claims_absence_state': json['is_pay_claims_absence_state'] == null ? undefined : json['is_pay_claims_absence_state'],
    };
}

export function IIsPayClaimsAbsencePropertyDtoToJSON(json: any): IIsPayClaimsAbsencePropertyDto {
    return IIsPayClaimsAbsencePropertyDtoToJSONTyped(json, false);
}

export function IIsPayClaimsAbsencePropertyDtoToJSONTyped(value?: IIsPayClaimsAbsencePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_pay_claims_absence': value['is_pay_claims_absence'],
        'is_pay_claims_absence_state': value['is_pay_claims_absence_state'],
    };
}

